import styled from '@emotion/styled';
import TestSelectors from '@racemap/utilities/consts/test_selectors';
import type { MenuProps } from 'antd';
import { Link } from 'react-router-dom';
import { toast } from 'src/lib/toast';
import { useStore } from '../../store/reducers';
import { IconCaretDown } from '../BasicComponents/Icons';
import { useAdminMenuItems } from './useAdminMenuItems';
import { useTrackersMenuItems } from './useTrackersMenuItems';

export const useMainNavItems = (showCarets = false): NonNullable<MenuProps['items']> => {
  const currentUser = useStore((s) => s.users.getter.currentUser());
  const isFake = currentUser?.fakeUser === true;
  const { toggleFakeUser } = useStore((s) => s.users.actions);
  const trackersItems = useTrackersMenuItems();
  const adminItems = useAdminMenuItems();

  const handleBackToAdmin = async () => {
    await toggleFakeUser();
    toast.success({ title: 'Admin Feature', message: 'You switched back to admin mode!' });
  };

  return [
    {
      key: '/admin/events',
      label: (
        <Link to="/admin/events" id="nav_link_events">
          Tracking Maps
        </Link>
      ),
    },
    trackersItems.length > 0
      ? {
          key: 'trackers',
          className: TestSelectors.admin.nav.dropdowns.trackers.toString(),
          label: showCarets ? (
            <LabelWithCaret id={TestSelectors.admin.nav.dropdowns.trackers.toString()}>
              Trackers
              <IconCaretDown />
            </LabelWithCaret>
          ) : (
            <span id={TestSelectors.admin.nav.dropdowns.trackers.toString()}>Trackers</span>
          ),
          children: trackersItems,
        }
      : null,
    adminItems.length > 0
      ? {
          key: 'admin',
          className: TestSelectors.admin.nav.dropdowns.admin.toString(),
          label: showCarets ? (
            <LabelWithCaret id={TestSelectors.admin.nav.dropdowns.admin.toString()}>
              Admin
              <IconCaretDown />
            </LabelWithCaret>
          ) : (
            <span id={TestSelectors.admin.nav.dropdowns.admin.toString()}>Admin</span>
          ),
          children: adminItems,
        }
      : null,
    {
      key: 'support',
      label: (
        <a href="https://docs.racemap.com/" id="nav_link_support" target="_blank" rel="noreferrer">
          Support
        </a>
      ),
    },
    isFake ? { key: 'back-admin', label: 'Back to Admin!', onClick: handleBackToAdmin } : null,
  ].filter((item) => item != null);
};

const LabelWithCaret = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 6px;
`;
